import type { MediaSwiperV1Attributes } from '@/features/media-swiper-v1/media-swiper-v1-type';

import { MediaSwiper } from '@/core/features';
export type MediaSwiperV1Props = MediaSwiperV1Attributes;

export default function MediaSwiperV1({ gallery }: MediaSwiperV1Props) {
    return (
        <div className={'full-width'}>
            <MediaSwiper
                imageOptions={{
                    height: 225,
                    layoutWidth: 100,
                    objectFit: 'cover',
                }}
                items={gallery}
                swiperOptions={{
                    debugName: 'MediaSwiperV1',
                    navigation: false,
                    swiperModuleType: 'gallery',
                }}
            />
        </div>
    );
}
